import Vue from 'vue';
import Vuex from 'vuex';
import jwt_decode from 'jwt-decode';
import moment from 'moment';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        menuVisible: false,
        jwt: Vue.localStorage?.get('jwt') || window.localStorage?.jwt,
        user: {
            admin: false,
            username: 'makairs',
        },
        pageLinks: {
            // kontroller: [
            //     {
            //         to: { name: 'kontrol-planlama' },
            //         label: 'Kontrol Planlama'
            //     },
            //     {
            //         to: { name: 'musteri-kontrolleri' },
            //         label: 'Eski Kontrol Sayfası'
            //     },
            // ]
        },
    },
    getters: {
        jwtData(state) {
            if (!state?.jwt) {
                return {};
            }
            try {
                return jwt_decode(state.jwt);
            }
            catch {
                console.error('error decoding jwt!', state.jwt);
                return {};
            }
        },
        isAdmin(state, getters) {
            return getters.jwtData?.role === 'admin';
        },
        tokenRemainingSeconds(state, getters) {
            if (!getters.jwtData?.exp) {
                return 0;
            }
            return moment.unix(getters.jwtData?.exp).diff(moment(), 'seconds');
        },
        isTokenValid(state, getters) {
            return getters.tokenRemainingSeconds > 0;
        },
    },
    mutations: {
        toggleMenu(state) {
            state.menuVisible = !state.menuVisible;
        },

        setUser(state, user) {
            state.user = user;
        },

        setPageLinks(state, links) {
            state.pageLinks = links;
        },

        setJWT(state, jwt) {
            Vue.localStorage.set('jwt', jwt);
            state.jwt = jwt;
        },

        clearJWT(state) {
            Vue.localStorage.remove('jwt');
            state.jwt = null;
        },
    },
    actions: {
        toggleMenu(context) {
            context.commit('toggleMenu');
        },

        setUser(context, user) {
            context.commit('setUser', user);
        },

        setPageLinks(context, links) {
            context.commit('setPageLinks', links);
        },

        setJWT(context, jwt) {
            context.commit('setJWT', jwt);
        },

        clearJWT(context) {
            context.commit('clearJWT');
        },
    }
})
